'use client';
import { useState, useCallback, useEffect } from 'react';

function setDarkModeFromSlide(l, r) {
    var e, o, i;
    let d = null == l ? void 0 : null === (e = l.querySelector('.swan-carousel-slide')) || void 0 === e ? void 0 : e.firstElementChild;
    r(null !== (i = null == d ? void 0 : null === (o = d.classList) || void 0 === o ? void 0 : o.contains('swan-dark-mode')) && void 0 !== i && i);
}
function usePromoBarDarkMode(o, i) {
    let [d, n] = useState(false), { beforeChange: t, children: u, skin: v } = i, a = useCallback((l, r)=>{
        var e, i, d;
        if (t && t(l, r), 'promo-bar' !== v) return;
        let u = null === (d = o.current) || void 0 === d ? void 0 : null === (i = d.innerSlider) || void 0 === i ? void 0 : null === (e = i.list) || void 0 === e ? void 0 : e.querySelectorAll('.slick-slide');
        u && setDarkModeFromSlide(u[r], n);
    }, [
        o,
        n,
        v,
        t
    ]);
    return useEffect(()=>{
        var l, r, e;
        if ('promo-bar' !== v) return;
        let i = null === (e = o.current) || void 0 === e ? void 0 : null === (r = e.innerSlider) || void 0 === r ? void 0 : null === (l = r.list) || void 0 === l ? void 0 : l.querySelector('.slick-current');
        i && setDarkModeFromSlide(i, n);
    }, [
        o,
        u,
        v
    ]), {
        forceDarkMode: d,
        beforeChange: a
    };
}

export { usePromoBarDarkMode };
